import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "./i18n/LangContext";
import { Cursor } from "./components/Cursor";
import { IntroLoader } from "./components/IntroLoader";
import { useLenis } from "./lib/lenis";
import Home from "./pages/Home";
import Concierge from "./pages/Concierge";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

function AppShell() {
  useLenis();
  return (
    <div className="App grain">
      <IntroLoader />
      <Cursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/concierge" element={<Concierge />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <AppShell />
    </LangProvider>
  );
}

export default App;
